@if (endpoint(); as src) {
  @for (p of [photo()]; track p?.medium ?? 'nopic') {
    @switch (mode()) {
      @case ('square') {
        <div class="relative aspect-square overflow-hidden" [ngClass]="[containerClass()]">
          <img
            [ngSrc]="src"
            fill
            [ngSrcset]="srcset()"
            [loaderParams]="loaderParams()"
            [sizes]="effectiveSizes()"
            [priority]="priority()"
            [loading]="effectiveLoading()"
            gsImageAccessibility
            [gsImgAlt]="alt()"
            [gsImgSeo]="seoDescription()"
            [attr.title]="title() || null"
            [ngClass]="[computedImgClass()]"
          />
        </div>
      }
      @case ('fill') {
        <div class="relative overflow-hidden" [ngClass]="[fillSizeClass(), containerClass()]" [gsResponsive]="{ height: containerHeight() }">
          <img
            [ngSrc]="src"
            fill
            [ngSrcset]="srcset()"
            [loaderParams]="loaderParams()"
            [sizes]="effectiveSizes()"
            [priority]="priority()"
            [loading]="effectiveLoading()"
            gsImageAccessibility
            [gsImgAlt]="alt()"
            [gsImgSeo]="seoDescription()"
            [attr.title]="title() || null"
            [ngClass]="[computedImgClass()]"
          />
        </div>
      }
      @case ('adaptive') {
        <div
          class="relative block w-full overflow-hidden"
          [ngClass]="[containerClass()]"
          [gsResponsive]="{ height: containerHeight() }"
          [style.aspectRatio]="intrinsicAspectRatio()"
        >
          <img
            [ngSrc]="src"
            fill
            [ngSrcset]="srcset()"
            [loaderParams]="loaderParams()"
            [sizes]="effectiveSizes()"
            [priority]="priority()"
            [loading]="effectiveLoading()"
            gsImageAccessibility
            [gsImgAlt]="alt()"
            [gsImgSeo]="seoDescription()"
            [attr.title]="title() || null"
            [ngClass]="[computedImgClass()]"
          />
        </div>
      }
      @default {
        <img
          [ngSrc]="src"
          [width]="intrinsicWidth()"
          [height]="intrinsicHeight()"
          [ngSrcset]="srcset()"
          [loaderParams]="loaderParams()"
          [sizes]="effectiveSizes()"
          [priority]="priority()"
          [loading]="effectiveLoading()"
          gsImageAccessibility
          [gsImgAlt]="alt()"
          [gsImgSeo]="seoDescription()"
          [attr.title]="title() || null"
          [ngClass]="[computedImgClass()]"
        />
      }
    }
  }
}
